import { styled } from './styled';
import { wx } from './wx';
import * as W from './types';

const w = styled;

export default styled;
export { W, w, wx };
